import React from "react"

const TagIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 512 512" style={{ width: size, height: size }} aria-hidden="true">
      <g>
      	<g>
      		<path fill="currentColor" d="M372.375,45.351c-0.022-17.655-14.337-31.961-31.996-31.961H206.402c-8.486,0-16.624,3.37-22.625,9.37L9.375,197.126
      			c-12.499,12.496-12.5,32.758-0.003,45.257l133.977,133.978c6.248,6.248,14.438,9.373,22.628,9.373
      			c5.155,0,10.254-1.384,14.925-3.86c17.094-14.077-8.197,10.383,182.102-179.878c6.003-6.002,9.375-14.142,9.375-22.63
      			C372.379,43.466,372.38,66.681,372.375,45.351z M356.379,179.365c0,4.274-1.665,8.293-4.687,11.315L177.289,365.049
      			c-3.022,3.022-7.04,4.686-11.314,4.686s-8.291-1.665-11.314-4.686L20.686,231.07C17.664,228.048,16,224.029,16,219.756
      			c0-4.274,1.665-8.292,4.687-11.314L195.089,34.075c3.022-3.021,7.039-4.685,11.313-4.685h133.978c8.822,0,16,7.178,16,16V179.365z
      			"/>
      	</g>
      </g>
      <g>
      	<g>
      		<path fill="currentColor" d="M404.379,45.39v149.974c0,4.274-1.665,8.293-4.687,11.315L210.663,395.674l11.313,11.314l189.028-188.994
      			c6.003-6.002,9.375-14.142,9.375-22.63V45.39H404.379z"/>
      	</g>
      </g>
      <g>
      	<g>
      		<path fill="currentColor" d="M284.379,69.39c-17.641,0-32,14.351-32,32s14.359,32,32,32s32-14.351,32-32S302.019,69.39,284.379,69.39z M284.379,117.39
      			c-8.828,0-16-7.18-16-16s7.172-16,16-16s16,7.18,16,16S293.207,117.39,284.379,117.39z"/>
      	</g>
      </g>
    </svg>
	)
}

export default TagIcon